import {
  cancelDependentsIncorporation,
  createEmployeeDependentsIncorporation,
  createInsuranceDependentsIncorporation,
  finishDependentsIncorporation,
  getDependentsIncorporationForm,
  getDependentsOfDependentsIncorporationForm,
  putDependentsOfDependentsIncorporationForm,
  putDocumentOfDependentsIncorporationForm,
  resendDependentsIncorporationForm,
  resendDependentsIncorporationNoDeliverableForm,
  sendToBrokerDependentsIncorporationForm,
  sendToInsuranceDependentsIncorporationForm,
  sendToInsuranceDependentsIncorporation,
  getPoliciesForDependentsIncorporation,
  getCompaniesForDependentsIncorporation,
  getDependentsIncorporationFormEmployee
} from '../../../network';
import { ticketService, dependantIncorporationService } from '@/network';

import {
  POST_EMPLOYEE_DEPENDENTS_INCORPORATION,
  POST_INSURANCE_DEPENDENTS_INCORPORATION,
  POST_RESEND_DEPENDENTS_INCORPORATION_FORM,
  POST_RESEND_DEPENDENTS_INCORPORATION_NO_DELIVERABLE_FORM,
  POST_SEND_TO_BROKER_DEPENDENTS_INCORPORATION_FORM,
  POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION_FORM,
  POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION,
  POST_CANCEL_DEPENDENTS_INCORPORATION,
  POST_FINISH_DEPENDENTS_INCORPORATION,
  PUT_DEPENDENTS_OF_DEPENDENTS_INCORPORATION,
  PUT_DOCUMENT_OF_DEPENDENTS_INCORPORATION,
  GET_DEPENDENTS_INCORPORATION_FORM,
  GET_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM,
  FETCH_DEPENDENTS_INCORPORATION_FORM,
  FETCH_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM,
  SET_DEPENDENTS_INCORPORATION_FORM,
  SET_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM,
  FETCH_POLICIES_FOR_DEPENDENTS_INCORPORATION_FORM,
  FETCH_COMPANIES_FOR_DEPENDENTS_INCORPORATION_FORM,
  FETCH_TICKET_DEPENDANTS_INCORPORATIONS,
  SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING,
  SET_TICKET_DEPENDANTS_INCORPORATIONS,
  GET_TICKET_DEPENDANTS_INCORPORATIONS,
  DELETE_TICKET_DEPENDANT_INCORPORATION,
  FETCH_DEPENDENTS_INCORPORATION_FORM_EMPLOYEE
} from '@/store/types';

const store = {};
const getDefaultState = () => ({
  dependants: {
    data: [],
    loading: false
  }
});

store.state = getDefaultState();

store.getters = {
  [GET_TICKET_DEPENDANTS_INCORPORATIONS](state) {
    return state.dependants;
  },
  [GET_DEPENDENTS_INCORPORATION_FORM](state) {
    return state.form;
  },
  [GET_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM](state) {
    return state.dependents;
  }
};

store.mutations = {
  [SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING](state, loading) {
    state.dependants.loading = loading;
  },
  [SET_TICKET_DEPENDANTS_INCORPORATIONS](state, dependants) {
    state.dependants.data = dependants;
  },
  [SET_DEPENDENTS_INCORPORATION_FORM](state, form) {
    state.form = form;
  },
  [SET_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM](state, dependents) {
    state.dependents = dependents;
  }
};

store.actions = {
  async [FETCH_TICKET_DEPENDANTS_INCORPORATIONS]({ commit }, id) {
    commit(SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING, true);
    commit(SET_TICKET_DEPENDANTS_INCORPORATIONS, []);
    try {
      const response = await ticketService.getDependantsIncorporations(id);
      commit(SET_TICKET_DEPENDANTS_INCORPORATIONS, response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching ticket dependants', error);
      console.error('Params:', id);
      throw error;
    } finally {
      commit(SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING, false);
    }
  },
  async [DELETE_TICKET_DEPENDANT_INCORPORATION](
    { commit, dispatch },
    { id, ticketId }
  ) {
    commit(SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING, true);
    try {
      const response =
        await dependantIncorporationService.deleteDependantIncorporation(id);
      return response.data;
    } catch (error) {
      console.error('Error deleting ticket dependant', error);
      console.error('Params:', id);
      throw error;
    } finally {
      commit(SET_TICKET_DEPENDANTS_INCORPORATIONS_LOADING, false);
      dispatch(FETCH_TICKET_DEPENDANTS_INCORPORATIONS, ticketId);
    }
  },
  async [POST_EMPLOYEE_DEPENDENTS_INCORPORATION](_, payload) {
    const response = await createEmployeeDependentsIncorporation(payload);
    return response.data;
  },
  async [POST_INSURANCE_DEPENDENTS_INCORPORATION](_, payload) {
    const response = await createInsuranceDependentsIncorporation(payload);
    return response.data;
  },
  async [FETCH_DEPENDENTS_INCORPORATION_FORM]({ commit }, token) {
    const response = await getDependentsIncorporationForm(token);
    commit(SET_DEPENDENTS_INCORPORATION_FORM, response.data);
    return response.data;
  },
  async [FETCH_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM]({ commit }, token) {
    const response = await getDependentsOfDependentsIncorporationForm(token);
    commit(SET_DEPENDENTS_OF_DEPENDENTS_INCORPORATION_FORM, response.data);
    return response.data;
  },
  async [PUT_DEPENDENTS_OF_DEPENDENTS_INCORPORATION](_, { token, dependents }) {
    const response = await putDependentsOfDependentsIncorporationForm({
      token,
      dependents
    });
    return response.data;
  },
  async [PUT_DOCUMENT_OF_DEPENDENTS_INCORPORATION](_, { token, payload }) {
    const response = await putDocumentOfDependentsIncorporationForm({
      token,
      payload
    });
    return response.data;
  },
  async [POST_RESEND_DEPENDENTS_INCORPORATION_FORM](_, token) {
    const response = await resendDependentsIncorporationForm(token);
    return response.data;
  },
  async [POST_RESEND_DEPENDENTS_INCORPORATION_NO_DELIVERABLE_FORM](_, token) {
    const response = await resendDependentsIncorporationNoDeliverableForm(
      token
    );
    return response.data;
  },
  async [POST_SEND_TO_BROKER_DEPENDENTS_INCORPORATION_FORM](_, token) {
    const response = await sendToBrokerDependentsIncorporationForm(token);
    return response.data;
  },
  async [POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION_FORM](_, token) {
    const response = await sendToInsuranceDependentsIncorporationForm(token);
    return response.data;
  },
  async [POST_CANCEL_DEPENDENTS_INCORPORATION](_, id) {
    const response = await cancelDependentsIncorporation(id);
    return response.data;
  },
  async [POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION](_, id) {
    const response = await sendToInsuranceDependentsIncorporation(id);
    return response.data;
  },
  async [POST_FINISH_DEPENDENTS_INCORPORATION](_, id) {
    const response = await finishDependentsIncorporation(id);
    return response.data;
  },
  async [FETCH_POLICIES_FOR_DEPENDENTS_INCORPORATION_FORM](_, rut) {
    const response = await getPoliciesForDependentsIncorporation(rut);
    return response.data;
  },
  async [FETCH_COMPANIES_FOR_DEPENDENTS_INCORPORATION_FORM](_, rut) {
    const response = await getCompaniesForDependentsIncorporation(rut);
    return response.data;
  },
  async [FETCH_DEPENDENTS_INCORPORATION_FORM_EMPLOYEE](_, token) {
    return new Promise((resolve, reject) => {
      getDependentsIncorporationFormEmployee(token)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default store;
